<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <v-icon style="font-size: 30px; height: 0px; margin-top:8.75svh; margin-left: 2svw; margin-right: 2svw;"
                        color="#3F616C">
                        error_outline</v-icon>
                    <p
                        style="margin-top:3svh; margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 16px; font-weight: 400;">
                        Ha ocurrido un error</p>
                    <p
                        style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 16px; font-weight: 400;">
                        al procesar la imagen</p>
                    <p
                        style="margin-top:5svh; margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 16px; font-weight: 300;">
                        Por favor,</p>
                    <p
                        style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; font-size: 16px; font-weight: 300;">
                        acuda a su cita médica</p>
                    <div style="display: flex; flex-flow: column; justify-content: flex-end; flex: 1 1 auto">
                        <p
                            style="margin-top:3.1svh; margin-left: auto; margin-right: auto; margin-bottom: 6.4svh; font-family: Lato; font-style: normal; color: #3F616C; text-align: center; font-size: 20px;">
                            ¡Gracias por colaborar!</p>
                    </div>
                </v-card>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import CardNav from '../CardNav.vue';
import { nextScreen } from '../../router/utils.js';

export default {
    name: 'ImageError',
    components: {
        CardNav
    },
    methods: {
        back() {
            nextScreen(this.$router, '/accesscode');
        }
    },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/errors/ImageError.vue